import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    width: '100%',
    padding: `0 ${spacing(3)}`
  },
  accordion: {
    '&:before': {
      display: 'none'
    }
  },
  accordionExpanded: {
    margin: '0 !important'
  },
  summary: {
    height: 55,
    paddingLeft: '1.5rem',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  heading: {
    fontSize: 20,
    fontWeight: 500,
    paddingBottom: '0.6rem',
    color: palette.text.primary
  },
  subHeading: {
    fontSize: 15,
    fontWeight: 500,
    color: palette.text.primary
  },
  subtitleMap: {
    fontSize: 14,
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.6)'
  },
  scoreLabel: {
    fontSize: 12,
    paddingRight: 5,
    color: 'rgba(0, 0, 0, 0.6)'
  },
  scoreInput: {
    '& .MuiInputBase-root': {
      '& .MuiOutlinedInput-input': {
        padding: '10px 15px'
      }
    }
  }
}))
